import { type Action, type AnyAction, combineReducers } from 'redux';

import type { AIAvatar, AIAvatarVoicePreset } from 'js/src/client';
import { aiVoiceFiltersSlice } from 'js/src/data/ai-voices-and-avatars/ai-voice-filters/ai-voice-filters-slice';
import { aiVoiceModalSlice } from 'js/src/data/ai-voices-and-avatars/ai-voice-modal/ai-voice-modal-slice';
import { aiVoicesSlice } from 'js/src/data/ai-voices-and-avatars/ai-voices/ai-voices-slices';
import {
    setAIAvatars,
    setAIAvatarVoicePresets,
    setAIVoiceoverBatchComplete,
} from 'js/src/data/ai-voices-and-avatars/ai-voices-and-avatars-actions';
import type { PlainJsStoreOrmData } from 'js/src/data/plain-js-store-orm';
import PlainJsStoreORM from 'js/src/data/plain-js-store-orm';
import type { DeepReadonly } from 'js/src/libs/consts';

type StoredAIAvatarVoicePreset = DeepReadonly<AIAvatarVoicePreset>;
type StoredAIAvatar = DeepReadonly<AIAvatar>;

export function aiAvatarVoicePresets(
    state: PlainJsStoreOrmData<StoredAIAvatarVoicePreset, number> = PlainJsStoreORM.createEmpty<
        StoredAIAvatarVoicePreset,
        number
    >().data,
    action: Action,
) {
    if (setAIAvatarVoicePresets.match(action)) {
        const orm = PlainJsStoreORM.createEmpty<StoredAIAvatarVoicePreset, number>();
        action.payload?.forEach((preset) => orm.pushItem(preset, 'id'));
        return orm.data;
    }
    return state;
}

export function aiAvatars(
    state: PlainJsStoreOrmData<StoredAIAvatar, number> = PlainJsStoreORM.createEmpty<
        StoredAIAvatar,
        number
    >().data,
    action: Action,
) {
    if (setAIAvatars.match(action)) {
        const orm = PlainJsStoreORM.createEmpty<StoredAIAvatar, number>();
        action.payload?.forEach((avatar) => orm.pushItem(avatar, 'id'));
        return orm.data;
    }
    return state;
}

export function aiVoiceoverBatchComplete(state = false, action: AnyAction) {
    if (setAIVoiceoverBatchComplete.match(action)) {
        return action.payload;
    }
    return state;
}

export const aiVoicesAndAvatars = combineReducers({
    aiVoices: aiVoicesSlice.reducer,
    aiVoiceModal: aiVoiceModalSlice.reducer,
    aiVoiceFilters: aiVoiceFiltersSlice.reducer,
    aiAvatarVoicePresets,
    aiAvatars,
    aiVoiceoverBatchComplete,
});

export type AiVoicesAndAvatarsState = ReturnType<typeof aiVoicesAndAvatars>;
